import { render, staticRenderFns } from "./PrivateFirms.vue?vue&type=template&id=0345b565&scoped=true&"
import script from "./PrivateFirms.vue?vue&type=script&lang=js&"
export * from "./PrivateFirms.vue?vue&type=script&lang=js&"
import style0 from "./PrivateFirms.vue?vue&type=style&index=0&id=0345b565&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0345b565",
  null
  
)

export default component.exports